export default {
	name: "indexView", // 专栏课程
	data() {
		return {
			navList: [],
			inputStr: "",
			rankPrice: "",
			rankTime: "",

			subjectList: [],
			selSubj: {},
			specialList: [],
			selSpec: {},

			courseList: [],
			page: 1,
			limit: 12,
			total: 200,

		};
	},
	props: ['current', 'subjId'],
	watch: {},
	created() {
		console.log("column created", this.current, this.subjId);
		const menuList = JSON.parse(localStorage.getItem("menuList"));
		if (menuList && menuList.data) {
			this.navList = menuList.data;
			console.log("this.navList", this.navList);
		}
	},
	async mounted() {
		this.getSubjectData();
		this.getCourseList();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async getSubjectData() {
			const courseRes = await this.$zkHttp.index$get_subject();
			console.log("courseRes", courseRes);
			this.subjectList = courseRes;
			if (courseRes && courseRes.length) {
				if (this.subjId) {
					courseRes.map(e => {
						if (e.subject_id == this.subjId) {
							this.selSubj = {
								...e
							};
							this.getSpecialList();
						}
					});
				} else {
					this.selSubj = {
						...courseRes[0]
					};
					this.getSpecialList();
				}
			}
		},
		onSelSubj(e) {
			this.selSubj = {
				...e
			};
			this.getSpecialList();
		},
		async getSpecialList() {
			const specialRes = await this.$zkHttp.index$get_special({
				page: 1,
				limit: 20,
				subject_id: this.selSubj.subject_id || '',
				group_id: '',
				course_type_id: '',
			});
			console.log("specialRes", specialRes);
			if (specialRes) {
				this.specialList = specialRes;
			}
		},
		async getCourseList() {
			const courseRes = await this.$zkHttp.index$get_course({
				special_id: this.selSpec.id || '',
				subject_id: '',
				course_type_id: '',
				teacher: '',
				price: '',
				price_sort: this.rankPrice,
				create_at: this.rankTime,
				seach_text: this.inputStr,
				page: this.page,
				limit: this.current == 'column' ? 5 : this.limit
			});
			console.log("courseRes", courseRes);
			if (courseRes) {
				this.courseList = courseRes || [];
				if (this.courseList.length < this.limit) {
					this.total = this.page * this.limit
				}
			}
		},
		onSelSpec(e) {
			console.log("onSelSpec", e);
			if (this.selSpec.id == e.id) {
				this.selSpec = {};
			} else {
				this.selSpec = e;
			}
			this.page = 1;
			this.total = 200;
			this.getCourseList();
		},
		onRankPrice() {
			const rankArr = ["", "desc", "asc"];
			this.rankPrice = rankArr[rankArr.indexOf(this.rankPrice) + 1];
			this.getCourseList();
		},
		onRankTime() {
			const rankArr = ["", "desc", "asc"];
			this.rankTime = rankArr[rankArr.indexOf(this.rankTime) + 1];
			this.getCourseList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getCourseList();
		},
		gotoDetail(e, type) {
			// group_id: 机构, subject_id: 科目, course_type_id: 类别, special_id: 专栏, course_id: 课程, teacher_id: 老师,
			if (type == 'special') {
				this.$router.push({
					name: 'columnDetail',
					query: {
						parent: 'column',
						special_id: e.id
					}
				});
			} else if (type == 'course') {
				this.$router.push({
					name: 'courseDetail',
					query: {
						parent: 'column',
						course_id: e.course_id
					}
				});
			}

		},
	},
};